import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MyEmailDetail } from '../models/email-channel.model';

@Injectable({ providedIn: 'root' })
export class EmailMessageApiService {
  private readonly base = `${environment.apiUrl}api/emails`;

  constructor(private http: HttpClient) {}

  getDetail(id: number): Observable<MyEmailDetail> {
    return this.http.get<MyEmailDetail>(`${this.base}/${id}`);
  }
}
